export const environment = {
  version: '4.21.1',
  production: true,
  tokenKey: 'api_token',
  apiBaseUrl: 'https://tecservice.app/api/v1/',
  cryptoKey: 'bxRIDUqlBOO9QWRxutD6dp2nscXEl96gkdfjA4Kfkd9',
  storagePrefix: '',
  storageEncryption: true,
  pusher: {
    key: '58cb750d5672b8a78bfc',
    cluster: 'us3',
    forceTLS: true,
  },
  mapApi: 'AIzaSyB2lZbZX7TcIQVwP2wn_bQSLURCAErlLhw',
};
